import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { applyDocumentLocale, isSupportedLocale, persistLocale, readStoredLocale, } from './locale-config.js';
import { defaultLocale, getLocale, setActiveLocale } from './runtime.js';
const LocaleContext = createContext(null);
function resolveInitialLocale(preferred) {
    if (preferred && isSupportedLocale(preferred)) {
        return preferred;
    }
    return readStoredLocale() ?? defaultLocale;
}
export function LocaleProvider({ children, accountLocale = null, }) {
    const [locale, setLocaleState] = useState(() => resolveInitialLocale(accountLocale));
    useEffect(() => {
        setActiveLocale(locale);
        persistLocale(locale);
        applyDocumentLocale(locale);
    }, [locale]);
    const setLocale = useCallback((next) => {
        // Sync module locale before React re-renders so `t()` in the same
        // update sees the new language (effect would run too late).
        setActiveLocale(next);
        if (isSupportedLocale(next)) {
            persistLocale(next);
            applyDocumentLocale(next);
        }
        setLocaleState(next);
    }, []);
    const value = useMemo(() => ({ locale, setLocale }), [locale, setLocale]);
    return _jsx(LocaleContext.Provider, { value: value, children: children });
}
export function useLocale() {
    const context = useContext(LocaleContext);
    if (!context) {
        // Allow non-provider usage (scripts / early boot) via module locale.
        return {
            locale: getLocale(),
            setLocale: (next) => {
                setActiveLocale(next);
                if (isSupportedLocale(next)) {
                    persistLocale(next);
                    applyDocumentLocale(next);
                }
            },
        };
    }
    return context;
}
//# sourceMappingURL=LocaleProvider.js.map